import { Outlet } from "react-router";

export default function OffersMainNavRoute() {
  return <Outlet />;
}
